import { BannerBadgeTypes } from './banner-badge-types.enum';
import { BannerKeys } from './banner-keys.enum';

export const BannerMetadata = {
  [BannerKeys.SelectAndArchiveFolders]: {
    releaseDate: '2023-01-01',
    type: BannerBadgeTypes.Tip,
    localStorageKey: 'select-and-archive-folders-banner',
  },
  [BannerKeys.DragAndDropFields]: {
    releaseDate: '2023-01-01',
    type: BannerBadgeTypes.Tip,
    localStorageKey: 'template-editor-drag-and-drop-fields',
  },
  [BannerKeys.FormAvailableInMobile]: {
    releaseDate: '2023-01-01',
    type: BannerBadgeTypes.Tip,
    localStorageKey: 'form-mobile-alert',
  },
  [BannerKeys.FormTableActions]: {
    releaseDate: '2023-01-01',
    type: BannerBadgeTypes.Tip,
    localStorageKey: 'form-table-actions-tip-banner',
  },
  [BannerKeys.PhotoSizesField]: {
    releaseDate: '2023-07-27',
    type: BannerBadgeTypes.New,
    localStorageKey: 'field-group-banner-photos',
  },
  [BannerKeys.SsoFeatureAvailable]: {
    releaseDate: '2023-08-08',
    type: BannerBadgeTypes.New,
    localStorageKey: 'sso-banner',
  },
  [BannerKeys.BulkAddPhotoTags]: {
    releaseDate: '2023-08-30',
    type: BannerBadgeTypes.New,
    localStorageKey: 'bulk-add-photo-tags-banner',
  },
};
